/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 일정 추가 모달
 * 버전 : 1.0
 * 파일명 : ModalContentAddSchedule.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * 수정 : 2025-07-07, 강동형 : 저작권 추가, UI 마진값 확실하게 조정
 * ================================================================ */

import { Divider } from '@mui/material'
import { useEffect } from 'react'
import styled from 'styled-components'
import { AlertSpan } from '../common/CommonStyled'
import ModalSelectType from './ModalSelectType'
import InputBoxOnChange from '../inputbox/InputBoxOnChange'
import { ModalAdSheduleAddStore } from 'src/stores/ModalStore'
import AddEtc from './AddEtc'
import DateRangePickerAdR_Recruit from './DateRangePickerAdR_Recruit'
import DatePickerAdR_StartJob from './DatePickerAdR_StartJob'
import DatePickerAdR_EndJob from './DatePickerAdR_EndJob'
import EtcElement from './EtcElement'

const PageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 24px;

    position: relative;
    margin-top: 24px;
    overflow-y: auto;
    max-height: 80vh;
`
const LabelWarpper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 720px;
  position:relative;
`

const LabelSpan = styled.div`
  flex: 1;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: auto;
  margin-top: 9.5px;
`

const ElementWrapper = styled.div`
  width: 512px;
`
const CircleWrapper = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
  });

const Circle = styled.div<{ isNow?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${({ isNow }) => (isNow ? '#FFF' : '#508A9C')};
  border: 2px solid #A7C5CD;
  filter: ${({ isNow }) =>
    isNow ? 'drop-shadow(0px 0px 4px rgba(49, 242, 189, 0.8))' : 'none'};
  z-index: 2;
  color: white;
  font-size: 12px;
`;

const Line = styled.div`
  position: absolute;
  height: 56px;
  background-color: #A7C5CD;
  flex-grow: 1;
  margin-top: 0px; // 바로 이어붙이기
  top: 8px;
  border: 1px solid #A7C5CD;
  z-index: 0;
`;


const ModalContentAddSchedule = () => {
  const title = ModalAdSheduleAddStore((state)=>state.title)
  const setField = ModalAdSheduleAddStore((state)=>state.setField)
  const certification = ModalAdSheduleAddStore((state)=>state.certification)
  const urlLink = ModalAdSheduleAddStore((state)=>state.urlLink)
  const reset = ModalAdSheduleAddStore((state)=>state.reset)
  const etc = ModalAdSheduleAddStore((state)=>state.etc)
  const recruitestartdate = ModalAdSheduleAddStore((state)=>state.recruitestartdate)
  const recruiteenddate = ModalAdSheduleAddStore((state)=>state.recruiteenddate)
  const startjob = ModalAdSheduleAddStore((state)=>state.startjob)
  const endjob = ModalAdSheduleAddStore((state)=>state.endjob)

  useEffect(()=>{
    return(()=>{
      reset()
    })
  },[])

  return (
    <>
    <PageWrapper>
      <LabelWarpper>
        <LabelSpan>선발유형</LabelSpan>
        <ElementWrapper><ModalSelectType/></ElementWrapper>
      </LabelWarpper>
      <LabelWarpper>
        <LabelSpan>
          <span style={{color:'#09A7D6'}}>*</span>
          <span> 공고명</span>
        </LabelSpan>
        <ElementWrapper>
          <div style={{width: '100%', height:'40px'}}>
            <InputBoxOnChange value={title} onChange={(e)=>setField('title',e.target.value)} height='40px'/>
            {!title && <AlertSpan $isValid={false}>공고 명을 입력해주세요</AlertSpan>}
          </div>
        </ElementWrapper>
      </LabelWarpper>
      <LabelWarpper>
        <LabelSpan>지원자격</LabelSpan>
        <ElementWrapper><InputBoxOnChange value={certification} onChange={(e)=>setField('certification',e.target.value)} height='40px'/></ElementWrapper>
      </LabelWarpper>
      <LabelWarpper>
        <LabelSpan>공고 URL</LabelSpan>
        <ElementWrapper><InputBoxOnChange value={urlLink} onChange={(e)=>setField('urlLink',e.target.value)} height='40px'/></ElementWrapper>
      </LabelWarpper>
      <Divider sx={{width:'100%', borderColor:'#D1D1D1'}}/>
      <LabelWarpper>
        <LabelSpan></LabelSpan>
        <ElementWrapper>
          <AddEtc title='과정 추가'/>
        </ElementWrapper>
      </LabelWarpper>
      <LabelWarpper>
        <div style={{position:'absolute', left:'-32px'}}>
          <CircleWrapper>
            <Circle>
              1
            </Circle>
            <Line />
          </CircleWrapper>
        </div>
        <LabelSpan>
          <span style={{color:'#09A7D6'}}>*</span>
          <span> 접수기간</span>
        </LabelSpan>
        <ElementWrapper>
          <div style={{width: '100%', height:'40px'}}>
            <DateRangePickerAdR_Recruit textAlign='center'/>
            {(!recruitestartdate || !recruiteenddate) && <AlertSpan $isValid={false}>접수 기간을 입력해주세요</AlertSpan>}
          </div>
        </ElementWrapper>
      </LabelWarpper>
      {etc.length !==0 &&
        etc.map((item, index) => (
          <EtcElement item={item} index={index}/>
        ))}
      <LabelWarpper>
        <div style={{position:'absolute', left:'-32px'}}>
          <CircleWrapper>
            <Circle>
              {etc.length+2}
            </Circle>
            <Line />
          </CircleWrapper>
        </div>
        <LabelSpan>
          <span style={{color:'#09A7D6'}}>*</span>
          <span> 입영일</span>
        </LabelSpan>
        <ElementWrapper>          
          <div style={{width: '100%', height:'40px'}}>
            <DatePickerAdR_StartJob textAlign='center'/>
            {!startjob && <AlertSpan $isValid={false}>입영일을 입력해주세요</AlertSpan>}
          </div>
        </ElementWrapper>
      </LabelWarpper>
      <LabelWarpper>
        <div style={{position:'absolute', left:'-32px'}}>
          <CircleWrapper>
            <Circle>
              {etc.length+3}
            </Circle>
            {/* <Line /> */}
          </CircleWrapper>
        </div>
        <LabelSpan>
          <span style={{color:'#09A7D6'}}>*</span>
          <span> 임관일</span>
        </LabelSpan>
        <ElementWrapper>          
          <div style={{width: '100%', height:'40px'}}>
            <DatePickerAdR_EndJob textAlign='center'/>
            {!endjob && <AlertSpan $isValid={false}>임관일을 입력해주세요</AlertSpan>}
          </div>
        </ElementWrapper>
      </LabelWarpper>
    </PageWrapper>
    </>
  )
}

export default ModalContentAddSchedule